module.exports = __webpack_public_path__ + "img/katarina_amenities_2.968621f9.jpg";